import { motion } from "framer-motion";
import { ShieldCheck, Lock, Database, FileCheck2 } from "lucide-react";
import { FaSalesforce } from "react-icons/fa";

const BADGES = [
    {
        icon: FileCheck2,
        label: "SOC-2",
        sub: "Compliance roadmap",
    },
    {
        icon: FaSalesforce,
        label: "Salesforce",
        sub: "OAuth native integration",
    },
    {
        icon: ShieldCheck,
        label: "Signal Layer",
        sub: "Real-time identity data",
    },
    {
        icon: Lock,
        label: "Encryption",
        sub: "AES-256 · TLS 1.3",
    },
    {
        icon: Database,
        label: "Zero-store",
        sub: "Ephemeral processing",
    },
    {
        icon: ShieldCheck,
        label: "Read-first",
        sub: "Human-in-the-loop",
    },
];

export default function Trust() {
    return (
        <section
            id="trust"
            data-testid="trust-section"
            className="relative py-28 lg:py-36 border-t border-white/5"
        >
            <div
                className="absolute top-0 left-1/2 -translate-x-1/2 h-px w-1/2 bg-gradient-to-r from-transparent via-[#10B981]/40 to-transparent"
                aria-hidden
            />

            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="max-w-3xl mx-auto text-center">
                    <div className="text-[11px] uppercase tracking-[0.25em] font-mono text-[#10B981] font-bold">
                        Trust &amp; Security
                    </div>
                    <h2 className="mt-4 font-display text-[36px] sm:text-[44px] lg:text-[56px] font-semibold leading-[1.05] tracking-[-0.025em]">
                        Built for{" "}
                        <span className="text-volt-gradient">SOC-2</span> from
                        day one.
                    </h2>
                    <p className="mt-5 text-[16px] leading-relaxed text-neutral-400">
                        Dendros doesn't store your data.{" "}
                        <span className="text-white">
                            We secure your pipeline.
                        </span>{" "}
                        Every verification runs through an ephemeral,
                        audit-logged pipeline — your contacts never live at
                        rest on our servers.
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                    {BADGES.map((b, i) => (
                        <motion.div
                            key={b.label}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.4, delay: i * 0.05 }}
                            data-testid={`trust-badge-${i}`}
                            className="group rounded-xl border border-white/[0.08] bg-white/[0.02] p-5 hover:border-[#10B981]/30 hover:bg-[#10B981]/[0.02] transition-colors"
                        >
                            <div className="h-9 w-9 rounded-md bg-black/60 border border-white/5 flex items-center justify-center text-[#10B981] group-hover:scale-105 transition-transform">
                                <b.icon size={18} />
                            </div>
                            <div className="mt-4 font-display text-[15px] font-medium text-white">
                                {b.label}
                            </div>
                            <div className="mt-0.5 text-[11px] text-neutral-500 font-mono tracking-wide">
                                {b.sub}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
